import React from "react";

type PendingTopic = { id: number; title: string; status: string };
export function PendingPublicationList({ topics, loading, error, onOpen }: {
  topics: PendingTopic[];
  loading: boolean;
  error?: string;
  onOpen: (id: number) => void;
}) {
  const pending = topics.filter(topic => topic.status === "ready_to_publish");
  return <div className="space-y-4 py-5">
    <h2 className="text-xl font-semibold">待發布</h2>
    {loading ? <p>載入待發布文章中</p> : error ? <p role="alert">{error}</p> : <>
      <p className="text-sm text-muted-foreground">{pending.length} 篇</p>
      {pending.length === 0 ? <p>目前沒有待發布文章</p> : pending.map(topic =>
        <button key={topic.id} type="button" onClick={() => onOpen(topic.id)} className="block w-full rounded-lg border p-5 text-left hover:border-foreground/30">
          <span className="text-sm text-muted-foreground">待發布</span>
          <h3 className="mt-2 text-lg font-semibold">{topic.title}</h3>
          <span className="mt-3 block text-sm">開啟原稿</span>
        </button>
      )}
    </>}
  </div>;
}
